<template>
  <ais-instant-search
    :search-client="searchClient"
    index-name="book_versions"
    class="flex-grow-1">
    <div class="row no-gutters mt-3" ref="top">
      <book-search-filters-sidebar />
      <div class="col-md-9">
        <div class="mb-3">
          <ais-search-box
            placeholder="Cerca per titolo, autore, ISBN o parola chiave"
            :value="value"
            @input="updateSearch"
            :class-names="{
            'ais-SearchBox-form': 'd-flex',
            'ais-SearchBox-input': 'form-control',
            'ais-SearchBox-submit': 'd-none',
            'ais-SearchBox-reset': 'd-none',
          }"
          />
        </div>
        <ais-hits>
          <template v-slot="{ items, sendEvent }">
            <div class="row mb-4">
              <div v-for="item in items" :key="item.id" class="col-lg-3 col-6 mb-4">
                <div class="row no-gutters">
                  <div class="col-md-6 px-0">
                    <book-version-card
                      :book-slug="item.slug"
                      :book-version-id="item.id"
                      :cover="item.cover"
                      :book-title="item.title"
                      :subscribed="subscribed"
                      :authors="item.authors" />
                  </div>

                  <div class="col-md-6">
                    <!-- Book content -->
                    <div class="book-content-wrapper mt-2 mt-md-4 text-center text-md-left">
                      <div class="book-title">
                        <a
                          class="h6 mb-0"
                          :href="`/book-versions/${item.slug}/${item.id}`"
                        >{{ item.title }}</a>
                      </div>

                      <div class="book-authors">
                        <a
                          v-for="author in item.authors"
                          :key="author.id"
                          :href="`/authors/${author.slug}`"
                          class="small mb-0"
                        >{{ author.name }}</a>
                      </div>

                      <!--
                      <div class="book-authors">
                        <p class="small font-weight-bold my-3">N. edizioni: {{$count_version}}</p>
                      </div>
                      -->
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </template>
        </ais-hits>
        <styled-search-navigation @click="pageClicked"/>
        <ais-stats />
      </div>
    </div>
  </ais-instant-search>
</template>

<script>
import BookVersionCard from "../Cards/BookVersionCard.vue";
import BookSearchFiltersSidebar from "./BookSearchFiltersSidebar.vue";
import StyledSearchNavigation from "./StyledSearchNavigation.vue";
export default {
  name: "BooksSearch",
  components: {
    StyledSearchNavigation,
    BookVersionCard,
    BookSearchFiltersSidebar,
  },
  props: {
    searchClient: Object,
    value: String,
    subscribed: Boolean,
  },
  methods: {
    updateSearch(value) {
      this.$emit('input', value ? value : "");
    },
    pageClicked() {
      document.getElementsByTagName('body')[0].scrollIntoView({ behavior: "smooth" })
    }
  }
}
</script>

<style scoped>

</style>
